/**
 * 地图API配置文件
 * 统一管理百度地图和高德地图的API Key
 */

export const MAP_CONFIG = {
  // 高德地图 API Key
  AMAP_KEY: '8ca70eabbc2140d47845784e97ec3a3c',
  
  // 百度地图 API Key
  BAIDU_KEY: '8eDPUZPpG9cCte0oixzpHkM4V7w1SwyI',
  
  // 高德地图API版本
  AMAP_VERSION: '1.4.5',
  
  // 百度地图API版本
  BAIDU_VERSION: '2.0'
}

export default MAP_CONFIG
